import { memo } from "react";
import { Card } from "react-bootstrap";

import "./Category.css";

const CategoryCard = ({ image, label, ...rest }) => {
  return (
    <Card className="border-0 hover-pointer" {...rest}>
      <Card.Img variant="top" src={image} className="category-card-image" />
      <Card.Title className="fs-14 text-truncate text-center mt-2 text-dark">{label}</Card.Title>
    </Card>
  );
};

export default memo(CategoryCard);
